<template>
    <div class="completed_content">
        <div class="completed_rabiu">
            <div :class="['completed_warp_top',$route.query.status == 1?'wait-title-content':$route.query.status == 2?'confirm-title-content':'completed_titel']">
                <div>
                    {{$route.query.text}}
                </div>
                <div class="completed_titel_right">
                    <div class="completed_titel_btn">
                        {{$route.query.status == 1?'待确认':$route.query.status == 2?'已确认':'待交付'}}
                    </div>
                    <div class="completed_titel_lebel" @click="goBack">
                        <img src="~@/assets/images/pagin/card_up.png" alt="">
                    </div>
                </div>
            </div>
            <div class="completed_warp">
                <div class="completed_warp_text">
                    <div>
                        尊敬的王小姐：
                    </div>
                    <div class="completed_text">
                        您好，您的{{$route.query.text}}已完工。A.O史密斯品牌监理已依据《冷暖风水系统质量管理标准》，对现场进行监理验收，均已全部合格，敬请确认！
                    </div>
                </div>
                <div class="completed_warp_table">
                    <div :class="['completed_warp_table_item',index%2 ==0?'completed_warp_backone':'']" v-for="(item,index) in objPoint.arrTag" :key="index" v-show="item.type == 1">
                        <div class="completed_table_text">{{item.name}}</div>
                        <div class="completed_table_num">{{item.num}}个</div>
                        <div class="completed_table_text">{{'已验收合格数量'}}</div>
                        <div class="completed_table_num">{{item.num}}个</div>
                        <div class="completed_table_icon"></div>
                    </div>
                </div>
                <div class="completed_userinfo">
                    <div class="userinfo_left">
                        <div class="header_img">
                            <img src="@/assets/images/user/house/head-img.png" alt="">
                        </div>
                        <div class="ren_user">
                            <div class="ren_user_one">监理：汪涵</div>
                            <!-- <div class="ren_user_two">2年工作经验 完工78个项目</div> -->
                            <div class="ren_user_two ren_user_two_on">验收时间：2021.12.25</div>
                        </div>
                    </div>
                    <div class="userinfo_right">
                        <img src="@/assets/images/pagin/tip_img_unlocking.png" alt="">
                    </div>
                </div>
                <div class="completed_tips">
                    <div class="completed_tips_left">
                        <div>特别</div>
                        <div>提醒</div>
                    </div>
                    <div class="completed_tips_right">
                        <div>1、产品保护膜请不要撕去</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="completed_detail_tips">
            <div class="completed_detail_padding">
                <div class="completed_detail_title">
                    验收详情
                </div>
                <!-- <div class="completed_sm_title">
                    <div>施工人员：</div>
                    <div class="dateTime">2021.11.01-12.21</div>
                </div> -->
                <div class="completed_userinfo">
                    <div class="userinfo_left">
                        <div class="header_img">
                            <img src="@/assets/images/user/house/head-img.png" alt="">
                        </div>
                        <div class="ren_user">
                            <div class="ren_user_three">项目经理：杨团结</div>
                            <!-- <div class="ren_user_two ren_user_two_on">2年工作经验<br>完工78个项目</div> -->
                        </div>
                    </div>
                    <div class="userinfo_left">
                        <div class="header_img">
                            <img src="@/assets/images/user/house/head-img.png" alt="">
                        </div>
                        <div class="ren_user">
                            <div class="ren_user_three">施工员：年伏伟</div>
                            <!-- <div class="ren_user_two ren_user_two_on">2年工作经验<br>完工78个项目</div> -->
                        </div>
                    </div>
                </div>
                <div class="completed_sm_title">
                    <div>验收清单</div>
                </div>
                <div class="completed_btn_padding">
                    <div class="completed_btn_sm">
                        <div :class="['completed_sm_btn',index == nSmBtnIndex ?'completed_sm_btn_back':'']" v-for="(item,index) in objPoint.arrTag" @click="nSmBtnIndex = index" :key="index">{{item.name}}</div>
                    </div>
                </div>
                <div class="completed_btn_sm_biaoqian" v-if="objPoint.arrTag[nSmBtnIndex].arrChlick.length">
                    <div class="completed_btn_bg">
                        <div v-show="item.name" :class="['completed_btn',index == nTopBtnIndex ?'completed_btn_back':'']" v-for="(item,index) in objPoint.arrTag[nSmBtnIndex].arrChlick" @click="nTopBtnIndex = index" :key="index">
                            {{item.name}}
                        </div>
                    </div>
                </div>
            </div>
            <van-swipe class="swiper_img" indicator-color="white" ref="vanswipe" v-if="objPoint.arrTag[nSmBtnIndex].arrChlick[nTopBtnIndex].arrImg.length">
                <van-swipe-item>
                    <div class="swipe_img_url" @click="getShow(objPoint.arrTag[nSmBtnIndex].arrChlick[nTopBtnIndex].arrImg[0].url)">
                        <img :src="objPoint.arrTag[nSmBtnIndex].arrChlick[nTopBtnIndex].arrImg[0].url" alt="">
                        <div class="swipe_img_label_two">施工标准</div>
                    </div>
                </van-swipe-item>
            </van-swipe>
            <div class="swiper_img" v-if="objPoint.arrTag[nSmBtnIndex].arrChlick[nTopBtnIndex].arrImg.length">
                <van-swipe class="swiper_img_url" ref="vanswipetwo" :autoplay="3000" indicator-color="white">
                    <van-swipe-item v-for="(item,index) in objPoint.arrTag[nSmBtnIndex].arrChlick[nTopBtnIndex].arrImg" :key="index">
                        <div class="swipe_img_url" @click="getShow(item.url)">
                            <img :src="item.url" alt="">
                            <div class="swipe_img_label">工地实况</div>
                        </div>
                    </van-swipe-item>
                </van-swipe>
                <div class="left_swiper" @click="prev('vanswipetwo')">
                    <img src="@/assets/images/pagin/left_swiper.png" alt="">
                </div>
                <div class="right_swiper" @click="next('vanswipetwo')">
                    <img src="@/assets/images/pagin/right_swiper.png" alt="">
                </div>
            </div>
            <div class="swiper_img_list">
                <div class="swiper_item_warp">
                    <div class="swiper_item_url" v-for="item in objPoint.arrTag[nSmBtnIndex].arrChlick[nTopBtnIndex].arrImg" :key="item.url">
                        <img :src="item.url" alt="">
                    </div>
                </div>
            </div>
            <div class="point_content">
                <div class="point_table">
                    <div class="point_table_one">验收质控点</div>
                    <div class="point_table_two">施工标准</div>
                    <div class="point_table_three">验收结果</div>
                </div>
                <div class="point_table_on">
                    <div class="point_table_item" v-for="(item,index) in objPoint.arrTag[nSmBtnIndex].arrChlick[nTopBtnIndex].arrZhikun" :key="item.name">
                        <div class="point_table_top">
                            <div class="point_table_one">
                                <div style="width:100px">{{item.name}}</div>
                            </div>
                            <div class="point_table_two">{{item.zhen}}</div>
                            <div class="point_table_three" :style="{'color':'#318544'}">{{item.zhen}}</div>
                        </div>
                        <div class="point_table_help">
                            {{item.help?'*'+item.help:''}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="evaluate" v-if="$route.query.status != 1">
            <div class="evaluate_tips">我的评价</div>
            <div class="eva-context-info">
                <div class="title">
                    <p>客户星级评价</p>
                    <img :src="require('@/assets/images/user/house/completion-star-icon.png')" v-for="item in 5" :key="item" alt="">
                    <div>5.0分</div>
                </div>
                <div class="tags">
                    <div class="tags_item" v-for="(tags,tagNum) in arrTag" :key="tagNum">{{tags}}</div>
                </div>
                <p class="eva-text">{{ '施工严谨，施工时未监工，觉得史密斯是个大公司，就特别信任' }}</p>
            </div>
        </div>
        <div class="evaluate" v-if="$route.query.id == 1">
            <div class="evaluate_tips">对本次冷暖风水系统产品及施工是否满意？</div>
            <div class="star-wrap">
                <div class="star-item fls" v-for="(item, index) in evaStarList" :key="index">
                    <div class="star-item-text">{{ item.title }}</div>
                    <div class="star-item-img flc">
                        <img v-for="(star, index2) in item.star" :key="index2" :src="star ? starSelect : starCommon" class="star" alt="" @click="lightStar(index, index2)" />
                    </div>
                </div>
            </div>
            <textarea class="advice-text" placeholder="您好，分享您的销售体验、施工体验等给我们更多建议，以便为您更好的服务。"></textarea>
            <div class="recording-btn flc">
                <img src="@/assets/images/user/house/record-icon.png" alt="">
                <div>点击录制评价语音</div>
            </div>
            <div class="addto">追加评价</div>
            <div class="addto_text">使用很舒服，会推荐给朋友</div>
            <div class="eveImg">
                <div class="eve_img_item" v-for="item in 2" :key="item">
                    <img v-lazy="" alt="">
                </div>
            </div>
        </div>
        <div class="bottom_btn">
            <div class="left_btn">
                有疑问
            </div>
            <div class="right_btn" @click="changeConfirmPopupVisible" v-if="$route.query.status == 1">
                确认验收
            </div>
        </div>
        <!--     确认验收弹窗      -->
        <Popup v-model="bConfirmPopupVisible" class="confirm-cover-popup">
            <!--            标题      -->
            <p class="title">{{ '对本次空调隐蔽工程的验收是否满意' }}</p>
            <!-- <p class="star-text">{{ '非常满意，无可挑剔' }}</p> -->
            <startEvaluate @scoreChange="scoreChange"></startEvaluate>
            <!--     标签       -->
            <div class="tags-content">
                <div @click="changeTagActive(tag.id)" v-for="(tag,tagIndex) in arrAcceptance" :key="tagIndex" class="tags-item" :class="{'tags-item-active':arrAcceptanceActive.includes(tag.id)}">
                    <p>{{ tag.name }}</p>
                </div>
            </div>
            <!--    文本输入控件       -->
            <div style="display:flex;">
                <span style="color:red;" v-if="nUserScore <= 3">*</span>
                <textarea class="text-input" placeholder="其他想说的" v-model="tagsText" />
            </div>
            <!--        提交按钮    -->
            <div class="commit-button">提交评价</div>
        </Popup>
        <!-- 预览图片 -->
        <van-image-preview v-model="pdfShow" :startPosition="lookImgIndex" :images="arrPdfImg" @change="lookChang">
            <template v-slot:imgIndex>第{{ imgIndex }}页</template>
        </van-image-preview>
    </div>
</template>

<script>
import oDeliver from "@/js/deliver.js";
import { Popup, Picker } from "vant";
import startEvaluate from "@/page/service/components/startevaluate";
export default {
    components: {
        Popup,
        VantPicker: Picker,
        startEvaluate,
    },
    data() {
        return {
            pdfShow: false, //查看图片
            lookImgIndex: 0,
            imgIndex: 0,
            arrPdfImg: [],
            nTopBtnIndex: 0,
            tagsText: "",
            state: 1,
            nSmBtnIndex: 0,
            arrTag: ["及时预约", "施工标准严苛"],
            arrAcceptance: [],
            arrAcceptanceActive: [],
            // 确认验收弹窗显示
            bConfirmPopupVisible: false,
            nUserScore: 5,
            arrSmBtn: [
                { name: "风机盘管安装8个质控点" },
                { name: "水力模块安装8个质控点" },
                { name: "核心配件安装" },
                { name: "系统管路" },
            ],
            arrTabel: [
                {
                    name: "风机盘管验收点",
                    nameNum: "8个",
                    yesName: "已验收合格数量",
                    yesNameNum: "8个",
                },
                {
                    name: "冷煤管验收点",
                    nameNum: "6个",
                    yesName: "已验收合格数量",
                    yesNameNum: "6个",
                },
                {
                    name: "冷凝水管验收点",
                    nameNum: "8个",
                    yesName: "已验收合格数量",
                    yesNameNum: "8个",
                },
                {
                    name: "试压及其他验收点",
                    nameNum: "8个",
                    yesName: "已验收合格数量",
                    yesNameNum: "8个",
                },
            ],
            objPoint: {},
            arrPoint: [
                {
                    color: "#318544",
                    pointName: "顶部与顶面之间间距",
                    standardName: "≥5mm",
                    resultName: "7mm",
                    helpTips: "*距离顶部大于等于5mm，预防机器引起共振。",
                },
                {
                    color: "#318544",
                    pointName: "顶部与顶面之间减震垫",
                    standardName: "有",
                    resultName: "有",
                    helpTips: "*吊干位置使用减震垫，减少运行噪音",
                },
                {
                    color: "#444444",
                    pointName: "风机盘管下部固定",
                    standardName: "双螺母/螺母加弹簧垫圈",
                    resultName: "双螺母",
                    helpTips: "*双螺母固定，提升安装可靠性",
                },
                {
                    color: "#444444",
                    pointName: "风机盘管与管道之间连接管",
                    standardName: "波纹软管",
                    resultName: "波纹软管",
                    helpTips: "*避免后期因震动导致管路连接",
                },
                {
                    color: "#318544",
                    pointName: "防尘保护",
                    standardName: "有",
                    resultName: "有",
                },
                {
                    color: "#318544",
                    pointName: "下送下回送回风口中心距",
                    standardName: ">1200mm",
                    resultName: "1300mm",
                },
                {
                    color: "#318544",
                    pointName: "保温厚度",
                    standardName: "≥20mm",
                    resultName: "30mm",
                },
            ],
        };
    },
    filters: {
        setState(e) {
            switch (e) {
                case "1":
                    return "待确认";
                    break;
                case "2":
                    return "已确认";
                    break;
                case "3":
                    return "待交付";
                    break;
            }
        },
    },
    created() {
        let _that = this;
        $init(() => {
            _that.objPoint = _that.$storage.getStorage("arrReport");
            // console.log(_that.objPoint);
            _that.getMemberTag();
        });
    },
    methods: {
        /**
         * 改变验收弹窗显示
         */
        changeConfirmPopupVisible() {
            let id = this.$route.query.id;
            if (id != 4) {
                this.bConfirmPopupVisible = !this.bConfirmPopupVisible;
                this.arrAcceptanceActive = [];
            } else {
                this.$router.push({ path: "/user/house/finish" });
            }
        },
        // 获取星星评价
        scoreChange(e) {
            this.nUserScore = e;
            this.getMemberTag();
        },
        // 评价tag
        getMemberTag() {
            let _that = this;
            oDeliver.getMemberTag({ rank: _that.nUserScore }).then((res) => {
                _that.arrAcceptance = res.result;
            });
        },
        getShow(e) {
            this.pdfShow = true;
            this.arrPdfImg = [e];
        },
        lookChang(e) {
            // console.log(e);
        },
        // 返回上一页
        goBack() {
            this.$router.go(-1); //返回上一层
        },
        prev(type) {
            let _that = this;
            _that.$refs[type].prev();
        },
        next(type) {
            let _that = this;
            _that.$refs[type].next();
        },
    },
};
</script>

<style lang="scss" scoped>
.my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    line-height: 150px;
    text-align: center;
    background-color: #39a9ed;
}
::v-deep .van-overlay {
    z-index: 99 !important;
}
.confirm-cover-popup {
    width: 580px;
    // height: 790px;
    border-radius: $commonRadius;
    background: #ffffff;
    padding: 40px 24px 32px;
    z-index: 100 !important;

    .title {
        color: $commonTitle;
        font-weight: 500;
        margin-bottom: 28px;
        line-height: 40px;
        text-align: center;
    }

    .star-text {
        color: #eb6f56;
        font-weight: 500;
        margin-bottom: 12px;
        line-height: 40px;
        text-align: center;
    }

    .tags-content {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-bottom: 8px;

        .tags-item {
            width: 256px;
            height: 80px;
            border: 2px solid #858585;
            border-radius: $commonRadius;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #858585;
            position: relative;
            margin-bottom: 20px;

            .active-icon {
                width: 36px;
                height: 36px;
                position: absolute;
                right: 12px;
            }
        }

        .tags-item-active {
            color: #fff;
            border-color: $deepGreen;
            background: $deepGreen;
        }
    }

    .text-input {
        height: 194px;
        padding: 24px 20px;
        background: #f7f7f7;
        border-radius: $commonRadius;
        width: 100%;
        resize: none;
        margin-bottom: 28px;
    }

    .commit-button {
        width: 532px;
        height: 92px;
        background: $greenGradient;
        border-radius: $commonRadius;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        font-weight: 500;
        font-size: $bigSize;
    }
}
/*通用样式*/
.flc {
    display: flex;
    align-items: center;
    justify-content: center;
}
.fls {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}
.evaluate {
    width: 100%;
    background: #fff;
    border-radius: 12px;
    margin-top: 20px;
    padding: 24px 24px 40px;
    box-sizing: border-box;
    .eveImg {
        display: flex;
        align-items: center;
        margin-top: 22px;
        .eve_img_item {
            width: 144px;
            height: 144px;
            background: #eeeeee;
            border-radius: 8px;
            margin-left: 20px;
            margin-bottom: 20px;
            overflow: hidden;
            &:first-child {
                margin-left: 0;
            }
            img {
                width: 100%;
                height: 100%;
            }
        }
    }
    .addto {
        color: #444444;
        font-weight: 700;
        font-size: 28px;
        margin-bottom: 12px;
        margin-top: 56px;
    }
    .addto_text {
        color: #444444;
        font-size: 28px;
    }
    .evaluate_tips {
        color: #318544;
        font-size: 32px;
        display: flex;
        align-items: center;
        font-weight: 700;
        &::before {
            content: "";
            display: inline-block;
            width: 6px;
            height: 32px;
            background: #318544;
            margin-right: 12px;
        }
    }
    .eva-context-info {
        background: linear-gradient(to right, #f1f1f1 50%, transparent 50%)
            repeat-x left bottom / 16px 2px;
        padding-bottom: 34px;
        margin-top: 28px;
        // margin-bottom: 28px;
        .tags {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            // margin-bottom: 20px;
            .tags_item {
                padding: 5px 10px;
                box-sizing: border-box;
                border-radius: 8px;
                border: 2px solid rgba(49, 133, 68, 0.3);
                color: #3d8f50;
                font-size: 24px;
                margin-right: 20px;
                margin-bottom: 20px;
            }
        }
        .title {
            display: flex;
            align-items: center;
            margin-bottom: 16px;
            font-size: 28px;

            & :first-child {
                line-height: 40px;
                margin-right: 24px;
            }

            img {
                width: 32px;
                height: 32px;
                margin-right: 16px;
            }
        }

        .eva-text {
            line-height: 32px;
            font-size: 28px;
            color: #a2a2a2;
        }
    }
    /*建议输入*/
    .advice-text {
        width: 100%;
        height: 248px;
        padding: 24px;
        background: #f7f7f7;
        border-radius: $commonRadius;
        resize: none;
    }

    /*录制按钮*/
    .recording-btn {
        width: 470px;
        height: 80px;
        margin: 24px auto 0;
        background: #649559;
        border-radius: 40px;
        img {
            width: 32px;
            height: 32px;
            margin-right: 12px;
        }
        font-size: $baseSize;
        font-weight: 400;
        color: #ffffff;
        line-height: 80px;
    }
    /*评星*/
    .star-wrap {
        width: 100%;
        margin: 32px 0 36px;

        .star-item {
            margin-bottom: 28px;

            &:last-child {
                margin-bottom: 0;
            }

            .star-item-text {
                font-size: $baseSize;
                font-weight: 400;
                color: $commonText;
                line-height: 40px;
                margin-right: 40px;
            }

            .star {
                width: 32px;
                height: 32px;
                margin-right: 32px;

                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }
}
.my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    line-height: 300px;
    text-align: center;
    background-color: #39a9ed;
}
.bottom_btn {
    width: 100%;
    padding: 0 28px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    // justify-content: space-between;
    justify-content: center;
    margin-top: 40px;
    .left_btn {
        width: 312px;
        height: 80px;
        border-radius: 12px;
        border: 2px solid #c77745;
        color: #c77745;
        font-size: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 10px;
        &::before {
            content: "";
            display: flex;
            width: 40px;
            height: 40px;
            background: url("~@/assets/images/pagin/icon_hollow.png") no-repeat
                center/100% 100%;
            margin-right: 4px;
        }
    }
    .right_btn {
        width: 312px;
        height: 80px;
        border-radius: 12px;
        color: #fff;
        font-size: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: $deepGreen;
        &::before {
            content: "";
            display: flex;
            width: 40px;
            height: 40px;
            background: url("~@/assets/images/pagin/seccess_icon.png") no-repeat
                center/100% 100%;
            margin-right: 4px;
        }
    }
}
.point_content {
    width: 100%;
    padding: 0 24px 0;
    box-sizing: border-box;
    margin-top: 28px;
    .point_table {
        padding-top: 32px;
        box-sizing: border-box;
        border-top: 1px dashed #f1f1f1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #444444;
        font-size: 28px;
        .point_table_one {
            width: 306px;
        }
        .point_table_two {
            width: 140px;
            text-align: center;
        }
        .point_table_three {
            width: 118px;
            text-align: center;
        }
    }
    .point_table_on {
        margin-top: 16px;
    }
    .point_table_item {
        padding: 24px 0 16px 0;
        box-sizing: border-box;
        width: 100%;
        border-bottom: 1px dashed #f1f1f1;
        .point_table_top {
            display: flex;
            // align-items: center;
            justify-content: space-between;
            font-size: 24px;
            .point_table_one {
                width: 306px;
                display: flex;
                // align-items: center;
                &::before {
                    content: "";
                    display: inline-block;
                    width: 36px;
                    height: 36px;
                    background: url("~@/assets/images/pagin/finish_icon.png")
                        no-repeat center/100% 100%;
                    margin-right: 10px;
                }
            }
            .point_table_two {
                width: 140px;
                text-align: center;
            }
            .point_table_three {
                width: 112px;
                text-align: center;
            }
        }
        .point_table_help {
            margin-top: 12px;
            color: #eb6f56;
            font-size: 20px !important;
        }
    }
}
.completed_content {
    width: 100%;
    min-height: 100vh;
    background: #f0f4f1;
    padding: 24px;
    box-sizing: border-box;
    .completed_rabiu {
        width: 100%;
        background: #ffffff;
        border-radius: $commonRadius;
        .completed_titel {
            background: #6c9276;
            .completed_titel_btn {
                color: #6c9276;
            }
        }
        .completed_warp_top {
            width: 100%;
            height: 100px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 24px 0 28px;
            box-sizing: border-box;
            color: #fff;
            font-size: $bigSize;
            border-radius: $commonRadius;
        }
        .completed_titel_right {
            display: flex;
            align-items: center;
            .completed_titel_btn {
                width: 114px;
                height: 44px;
                background: #ffffff;
                border-radius: 22px;
                border: 2px solid rgba(255, 255, 255, 0.3);
                font-size: $smallSize;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .completed_titel_lebel {
                width: 48px;
                height: 48px;
                margin-left: 24px;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .wait-title-content {
            background: #e3a751;
            .completed_titel_btn {
                color: #e3a751;
            }
        }

        .confirm-title-content {
            background: $greenGradient;
            .completed_titel_btn {
                color: $deepGreen;
            }
        }
        .completed_warp {
            width: 100%;
            padding: 24px;
            box-sizing: border-box;
            .completed_warp_text {
                color: #2f2f2f;
                font-size: $baseSize;
                .completed_text {
                    margin-top: 16px;
                    text-indent: 2em;
                    text-align: justify;
                }
            }
            .completed_warp_table {
                margin-top: 24px;
                .completed_warp_backone {
                    background: #f7f7f7;
                }
                .completed_warp_table_item {
                    display: flex;
                    align-items: center;
                    padding: 0 24px;
                    width: 100%;
                    height: 60px;
                    box-sizing: border-box;
                    .completed_table_text {
                        width: 37%;
                    }
                    .completed_table_num {
                        width: 10%;
                    }
                    .completed_table_icon {
                        width: 6%;
                        display: flex;
                        justify-content: flex-end;
                        &::before {
                            content: "";
                            display: flex;
                            width: 28px;
                            height: 28px;
                            background: url("~@/assets/images/pagin/hege_icon.png")
                                no-repeat center/100% 100%;
                        }
                    }
                }
            }
            .completed_tips {
                display: flex;
                margin-top: 22px;
                .completed_tips_left {
                    width: 84px;
                    height: 84px;
                    background: linear-gradient(
                        136deg,
                        #4ea062 0%,
                        #338444 100%
                    );
                    border-radius: 12px;
                    border: 2px solid rgba(255, 255, 255, 0.5);
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    font-size: 24px;
                    color: #fff;
                }
                .completed_tips_right {
                    display: flex;
                    height: 84px;
                    // align-items: center;
                    flex-direction: column;
                    justify-content: center;
                    margin-left: 20px;
                    color: #eb6f56;
                    font-size: 24px;
                }
            }
        }
    }
    .completed_userinfo {
        margin-top: 20px;
        padding: 30px 0;
        box-sizing: border-box;
        border-top: 1px dashed #f1f1f1;
        border-bottom: 1px dashed #f1f1f1;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .userinfo_left {
            display: flex;
            .header_img {
                width: 90px;
                height: 90px;
                border-radius: 50%;
                overflow: hidden;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .ren_user {
                margin-left: 20px;
                .ren_user_one {
                    font-size: 32px;
                    color: #222222;
                    font-weight: 700;
                }
                .ren_user_two {
                    font-size: 24px;
                    color: #a2a2a2;
                    margin-top: 4px;
                }
                .ren_user_two_on {
                    margin-top: 8px;
                }
                .ren_user_three {
                    font-size: 24px;
                    color: #444444;
                    height: 100%;
                    display: flex;
                    align-items: center;
                }
            }
        }
        .userinfo_right {
            width: 128px;
            height: 128px;
            border-radius: 50%;
            img {
                width: 100%;
                height: 100%;
            }
        }
    }
    .completed_detail_padding {
        padding: 24px 24px 0;
        box-sizing: border-box;
    }
    .completed_detail_tips {
        width: 100%;
        border-radius: $commonRadius;
        background: #fff;
        margin-top: 24px;
        .completed_detail_title {
            color: $deepGreen;
            font-size: $bigSize;
            display: flex;
            align-items: center;
            font-weight: 700;
            &::before {
                content: "";
                display: flex;
                width: 6px;
                height: 32px;
                background: $deepGreen;
                margin-right: 12px;
            }
        }
        .completed_sm_title {
            font-size: 28px;
            color: #444444;
            display: flex;
            align-items: flex-end;
            margin-top: 18px;
            justify-content: space-between;
            .dateTime {
                color: #a2a2a2;
                font-size: 24px;
            }
        }
        .completed_btn_padding {
            padding-bottom: 24px;
            border-bottom: 1px dashed #f1f1f1;
            box-sizing: border-box;
        }
        .completed_btn_sm_biaoqian {
            padding-top: 22px;
            padding-bottom: 32px;
            box-sizing: border-box;
            width: 100%;
            overflow: auto;
            overflow-y: hidden;
            display: flex;
            &::-webkit-scrollbar {
                width: 0 !important;
                height: 0 !important;
                color: transparent !important;
                display: none;
            }
            .completed_btn_bg {
                display: flex;
            }
        }
        .install_title {
            font-weight: 700;
            font-size: 36px;
            color: #262525;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 30px;
            margin-bottom: 12px;
            &::before {
                content: "";
                display: flex;
                width: 200px;
                height: 2px;
                background: #efefef;
                margin-right: 18px;
            }
            &::after {
                content: "";
                display: flex;
                width: 200px;
                height: 2px;
                background: #efefef;
                margin-left: 18px;
            }
        }
        .swiper_img {
            width: 100%;
            height: 320px;
            position: relative;
            margin-top: 8px;
            .swipe_img_url {
                width: 100%;
                height: 320px;
                position: relative;
                .swipe_img_label_two {
                    width: 140px;
                    height: 56px;
                    background: $deepGreen;
                    border-radius: 12px 0px 12px 0px;
                    color: #fff;
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 28px;
                }
                .swipe_img_label {
                    width: 140px;
                    height: 56px;
                    background: rgba(0, 0, 0, 0.4);
                    border-radius: 12px 0px 12px 0px;
                    color: #fff;
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 28px;
                }
                img {
                    width: 100%;
                    height: 320px;
                }
            }
            .left_swiper {
                position: absolute;
                width: 34px;
                height: 48px;
                top: 0;
                bottom: 0;
                left: 0;
                margin: auto 0;
                img {
                    width: 34px;
                    height: 48px;
                }
            }
            .right_swiper {
                position: absolute;
                top: 0;
                bottom: 0;
                margin: auto 0;
                right: 0;
                width: 34px;
                height: 48px;
                img {
                    width: 34px;
                    height: 48px;
                }
            }
        }
        .swiper_img_list {
            width: 100%;
            margin-top: 8px;
            display: flex;
            overflow: auto;
            overflow-y: hidden;
            &::-webkit-scrollbar {
                width: 0 !important;
                height: 0 !important;
                color: transparent !important;
                display: none;
            }
            .swiper_item_warp {
                display: flex;
                // align-items: center;
                // justify-content: space-between;
                .swiper_item_url {
                    flex: 1;
                    width: 168px;
                    height: 128px;
                    background: #d8d8d8;
                    margin-right: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    &:last-child {
                        margin-right: 0;
                    }
                }
            }
        }
        .completed_btn {
            // flex: 1;
            margin-left: 16px;
            padding: 10px 20px;
            white-space: nowrap;
            // width: 300px;
            box-sizing: border-box;
            border-radius: 40px;
            border: 2px solid #84c295;
            display: flex;
            align-items: center;
            justify-content: center;
            color: $deepGreen;
            font-size: $baseSize;
        }
        .completed_btn_sm {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            justify-content: space-between;
            .completed_sm_btn {
                margin-top: 16px;
                width: 318px;
                height: 80px;
                border-radius: 12px;
                border: 2px solid #84c295;
                display: flex;
                justify-content: center;
                align-items: center;
                color: $deepGreen;
                font-size: $baseSize;
            }
            .completed_sm_btn_back {
                color: #fff;
                background: $deepGreen;
            }
        }
        .completed_btn_back {
            color: #fff;
            background: $deepGreen;
        }
    }
}
</style>